import SendNotificationModal from "../../../components/Renewal/SendNotificationModal";
import AddCommentModal from "../../../components/Renewal/AddCommentModal";
import FollowupHistoryModal from "../../../components/Renewal/FollowupHistoryModal";
import { getFollowUpComments, updateSegmentsHttp, updateZoneHttp } from "../../../http/renewalHttp/RenewalHttp";
import Div from "../../../components/Div"
import PageTitle from "../../../components/PageTitle"
import FormButton from "../../../components/FormButton"
import Input from "../../../components/Input"
import { Stack, Pagination, Card, CardContent, Typography } from "@mui/material"
import { useState, useEffect } from "react"
import { getMyDomain } from "../../../http/renewalHttp/RenewalMemberHttp"
import { zones, segments } from "../../../util/enum"
import Select from "../../../components/Select"


export default function MyRenewalDomain() {


    const [customerList, setCustomerList] = useState([]);
    // const [isAscending, setIsAscending] = useState(true);
    const [initailCustomerList, setInitialCustomerList] = useState([])
    const [search, setSearch] = useState('')
    const [addComment, setAddComment] = useState(false);
    const [followupHistory, setFollowupHistory] = useState(false);
    const [sendNotification, setSendNotification] = useState(false);
    // const [startDate, setStartDate] = useState(new Date())
    // const [endDate, setEndDate] = useState(new Date())

    const [currentPage, setCurrentPage] = useState(1);

    const [month, setMonth] = useState('')

    const itemsPerPage = 20;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const currentItems = customerList.slice(indexOfFirstItem, indexOfLastItem);

    // Calculate total pages
    const totalPages = Math.ceil(customerList.length / itemsPerPage);

    // Change page
    const paginate = (event, value) => {
        setCurrentPage(value);
    };

    const zone = zones.zone.map((zone) =>
        zone.id !== currentItems ?
            <option key={zone.id}
                name={zone.id}
                value={zone.id}>
                {zone.value}</option>
            : null);

    const state = segments.segment.map((state) =>
        state.id !== currentItems ?
            <option key={state.id}
                name={state.id}
                value={state.id}>
                {state.value}</option>
            : null)


    const getMyDomains = async () => {
        const response = await getMyDomain()
        if (response) {
            setCustomerList(response.domains)
            setInitialCustomerList(response.domains)
        } else {
            // window.location.href = '/error'
            // alert('Could not fetch data. Please contact your Administrator')
        }
    }

    useEffect(() => {
        getMyDomains()
    }, [])

    async function handleFollowUp(renewal_id) {
        const followUpCommentResponse = await getFollowUpComments(renewal_id)
        // if (followUpCommentResponse){
        const followComments = {
            'renewal_id': renewal_id,
            'followupComments': followUpCommentResponse ? followUpCommentResponse.followup_comment : []
        }
        setFollowupHistory(followComments)

    }


    function handleSearchCustomer(event) {

        const search_item = event.target.value;

        const filteredList = initailCustomerList.filter((customer) => {

            if ((customer && customer.customerDomain)) {

                return customer.customerDomain.toLowerCase().includes(search_item.toLowerCase());
            }
            else {
                return false
            }
        });
        setCustomerList(filteredList);
        setSearch(search_item)
    }

    function handleMonthChange(event) {
        const filterMonth = event.target.value

        if (search) {
            const filteredList = initailCustomerList.filter((customer) => {

                if ((customer && customer.customerDomain)) {
                    return customer.customerDomain.toLowerCase().includes(search.toLowerCase());
                }
                else {
                    return false
                }
            }).filter((customer) => {

                if ((customer && customer.renewal_date)) {
                    // eslint-disable-next-line
                    const [day, month, year] = customer.renewal_date.split('-')
                    const formattedDate = `${year}-${month}`
                    return formattedDate.includes(filterMonth)

                    // return customer.renewal_date.includes(filterMonth)
                }
                else {
                    return false
                }
            });

            setCustomerList(filteredList)
            setMonth(filterMonth)
        }
        else {

            const filteredList = initailCustomerList.filter((customer) => {

                if ((customer && customer.customerDomain)) {
                    // eslint-disable-next-line
                    const [day, month, year] = customer.renewal_date.split('-')
                    const formattedDate = `${year}-${month}`
                    return formattedDate.includes(filterMonth)
                }
                else {
                    return false
                }
            });
            setCustomerList(filteredList);
            setMonth(filterMonth)
        }
    }

    const handleUpdateSelect = async (renewal_id, field, value) => {
        setCustomerList(prevList =>
            prevList.map(customer =>
                customer.renewal_id === renewal_id ? { ...customer, [field]: value } : customer
            )
        );

        if (field === 'zone') {
            // updateZone
            const zoneResponse = await updateZoneHttp(renewal_id, value)
            if (zoneResponse) {

            }
            else {
                alert('Failed to Update Zone. Please try refreshing the page')
            }
        }
        else if (field === 'segments') {
            // update Segment

            const segmentResponse = await updateSegmentsHttp(renewal_id, value)
            if (segmentResponse) {

            }
            else {
                alert('Failed to Update Segment. Please try refreshing the page')
            }
        }
    };

    function handleSendNotification(domain_name, renewal_id, subscription_id, renewal_date, zoho_contact_id) {
        const notifyData = {
            'domain_name': domain_name,
            'renewal_id': renewal_id,
            'subscription_id': subscription_id,
            'renewal_date': renewal_date,
            'zoho_contact_id': zoho_contact_id
        }
        console.log(notifyData)
        setSendNotification(notifyData)
    }

    function handleAddComment(renewal_id) {

        setAddComment(renewal_id);

    }

    // function handleStartDateChange(event) {
    //     const start_date = event.target.value
    //     setStartDate(start_date)

    // }


    // function handleEndDateChange(event) {
    //     // console.log(event.target.value)
    //     const end_date = event.target.value
    //     const start = new Date(startDate);
    //     const end = new Date(end_date);
    //     setEndDate(end_date)
    //     // filterByDate(startDate, end_date)
    //     console.log(end_date, startDate)
    //     if (startDate) {

    //         const filteredList = initailCustomerList.filter((customer) => {
    //             if ((customer && customer.renewal_date)) {
    //                 // console.log(customer.renewal_date)
    //                 const [day, month, year] = customer.renewal_date.split('-');
    //                 const renewalDate = new Date(`${year}-${month}-${day}`);
    //                 console.log(renewalDate)
    //                 return renewalDate >= start && renewalDate <= end;
    //             }
    //             else {
    //                 return false
    //             }
    //         });
    //         // console.log(filteredList)
    //         setCustomerList(filteredList)

    //     }

    // }


    // function handleEndDateChange(event) {
    //     const end_date = event.target.value;
    //     setEndDate(end_date);
    
    //     const start = new Date(startDate);
    //     const end = new Date(end_date);
    
    //     // Normalize start and end to remove time component
    //     start.setHours(0, 0, 0, 0);
    //     end.setHours(23, 59, 59, 999); // Include the whole end date
    
    //     console.log("Start Date:", start);
    //     console.log("End Date:", end);
    
    //     if (startDate) {
    //         const filteredList = initailCustomerList.filter((customer) => {
    //             if (customer?.renewal_date) {
    //                 // Convert "DD-MM-YYYY" to "YYYY-MM-DD"
    //                 const [day, month, year] = customer.renewal_date.split('-');
    //                 const renewalDate = new Date(`${year}-${month}-${day}`);
    //                 renewalDate.setHours(0, 0, 0, 0); // Normalize to 00:00:00
    
    //                 console.log("Renewal Date:", renewalDate);
    
    //                 return renewalDate >= start && renewalDate <= end;
    //             }
    //             return false;
    //         });
    
    //         setCustomerList(filteredList);
    //     }
    // }
    
   

    // const formatDate = (timestamp) => {
    //     const date = new Date(timestamp);
    //     const day = String(date.getDate()).padStart(2, '0');
    //     const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    //     const year = date.getFullYear();

    //     return `${day}/${month}/${year}`;
    // };

    return <>

        {sendNotification ? <SendNotificationModal notify={sendNotification} show={true.toString()} open handleClicked={setSendNotification} /> : null}
        {addComment ? <AddCommentModal comments={addComment} show={true.toString()} open handleClicked={setAddComment} /> : null}
        {followupHistory ? <FollowupHistoryModal history={followupHistory} show={true.toString()} open handleClicked={setFollowupHistory} /> : null}


        <PageTitle title='Renewal Domains' />

        <Div className="col-md-12">
            <Div className="page-header-toolbar">

                <Div className="btn-group toolbar-item" role="group" >

                    <Input type="text" name="email" id="email" placeholder='Enter Domain Name'
                        value={search}
                        onChange={handleSearchCustomer}
                    />

                    <Input type='month' name='month' id='month' style={{ marginLeft: '50px' }} value={month}
                        onChange={handleMonthChange}
                    />

                    {/* <Input type='date' name='start_date' id='start_date' style={{ marginLeft: '50px' }} value={startDate}
                        onChange={handleStartDateChange}
                    />

                    <Input type='date' name='end_date' id='end_date' style={{ marginLeft: '50px' }} value={endDate}
                        onChange={(e) => { if (e.target.value) handleEndDateChange(e) }}
                    /> */}

                   
                </Div>
                <Card variant="outlined" sx={{ mb: 2 }} style={{marginLeft: '50px'}}>
                        <CardContent>
                            <Typography variant="body1"> <strong> Total Domains: </strong> {customerList.length ?? 0} </Typography>

                        </CardContent>
                    </Card>
            </Div>
        </Div>

        <Div className="col-md-12 margin_top">
            {currentItems.length > 0 ?
                <table className="table" border="1">
                    <thead>
                        <tr>
                            <th>Customer Domain</th>
                            <th>Plan</th>
                            <th>Status</th>
                            <th>Users</th>
                            <th>License</th>          
                            <th>Sku Id</th>
                            <th className="sortable-header"
                            // onClick={() => handleSort("renewal_date")}
                            >Renewal Date
                                {/* {sortColumn === "renewal_date" ? (
                                    sortOrder === "asc" ? (
                                        <FaSortUp className="sort-icon" />
                                    ) : (
                                        <FaSortDown className="sort-icon" />
                                    )
                                ) : (
                                    <FaSort className="sort-icon" /> // Default sort icon
                                )} */}
                            </th>
                            <th>Zone</th>
                            <th>Google Renewal Date</th>
                            <th>Price</th>
                            <th>Segments</th>
                            <th>Add Comment</th>
                            <th>Follow up History</th>
                            <th>Follow Up Comments</th>
                            <th>Highlighted Case Flag</th>
                            <th>Confirmation Status</th>
                            <th>Aggrement Status</th>
                            <th>Price Per User</th>
                            <th>Special Comment</th>
                            <th>Task Status</th>
                            <th>Renewed License</th>
                            <th>Extension Date</th>

                            <th></th>
                        </tr>
                    </thead>
                    <tbody id="tableBody">
                        {currentItems.map((customer) =>
                            <>

                                <tr key={customer.renewal_id}>
                                    <td>
                                        {customer.customerDomain}
                                    </td>
                                    <td>{customer.plan_name}</td>
                                    <td>{customer.status}</td>
                                    <td>{customer.licensed_seats}</td>
                                    <td>{customer.number_of_seats}</td>
                                    <td>{customer.sku_name}</td>
                                    <td>{customer.renewal_date}</td>
                                    <td>
                                        <Select name='zone' options={zone} defaultValue={customer.zone}
                                            onChange={(e) => handleUpdateSelect(customer.renewal_id, 'zone', e.target.value)}

                                            style={{ width: 'auto' }} />
                                    </td>
                                    <td>{customer.google_renewal_data}</td>
                                    <td>{customer.price}</td>
                                    <td>
                                        <Select name='user_status' options={state} defaultValue={customer.segments}
                                            onChange={(e) => handleUpdateSelect(customer.renewal_id, 'segments', e.target.value)}

                                            style={{ width: 'auto' }} />
                                        {/* {customer.segments} */}
                                    </td>
                                    <td>
                                        <FormButton
                                            type='button'
                                            className="btn btn-primary submit-btn btn-block"
                                            onClick={() => handleAddComment(customer.renewal_id)}
                                        >Add Comments</FormButton>
                                    </td>

                                    <td>
                                        <FormButton
                                            type='button'
                                            className="btn btn-primary submit-btn btn-block"
                                            onClick={() => handleFollowUp(customer.renewal_id)}
                                        >Follow up History</FormButton>
                                    </td>
                                    <td>{customer.followup_comments}</td>
                                    <td>{customer.highlight_case}</td>
                                    <td>{customer.confirmation_status}</td>
                                    <td>
                                        {customer.agreement_status}
                                    </td>
                                    <td>{customer.price_per_user}</td>
                                    <td>{customer.special_comments}</td>
                                    <td>{customer.task_status ? customer.task_status : customer.reason}</td>
                                    <td>{customer.add_lic}</td>
                                    <td>{customer.extension_date}</td>
                                    <td>
                                        <FormButton
                                            type='button'
                                            className="btn btn-link"
                                            onClick={() => handleSendNotification(customer.customerDomain, customer.renewal_id, 
                                                customer.subscriptionId, customer.renewal_date, customer.zoho_contact_id)}
                                        >Send Notification</FormButton>
                                    </td>
                                </tr>
                            </>
                        )

                        }
                    </tbody>
                </table> :
                <>
                    <p style={{ marginTop: '30px' }}>Loading Monthly Renewal Data</p>
                </>}

            {currentItems.length > 0 ?
                <Stack spacing={2}>
                    <Pagination count={totalPages} color="primary" page={currentPage} onChange={paginate}>

                    </Pagination>

                </Stack> : null
            }
        </Div>

    </>
}